<template>
  <div>
    <div class="navigate">
      <select @change="onchange" class="page-demo">
        <option value="1">Full demo</option>
        <option value="2">Simple demo</option>
      </select>
    </div>
    <div>
      <App v-if="viewIndex == 1"></App>
      <Editor v-else-if="viewIndex == 2"></Editor>
    </div>
  </div>
</template>

<script>
import app from './app.vue';
import editor from './editor.vue';

export default {
  name: 'demo',
  components: {
    App: app,
    Editor: editor
  },
  data() {
    return {
      viewIndex: 1
    };
  },
  methods: {
    onchange(event) {
      this.viewIndex = event.target.value;
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
.navigate {
  text-align: center;
  font-size: 18px;
  color: blue;
}

.navigate span {
  margin-right: 5px;
}

.navigate span:hover {
  cursor: pointer;
  font-weight: bolder;
}

.page-demo {
  position absolute
  top 30px
  right 8%
}
</style>



// WEBPACK FOOTER //
// demo.vue?1e135f49